/* import __COLOCATED_TEMPLATE__ from './billing-and-payments-tab.hbs'; */
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class SiteBillingBillingAndPaymentsTab extends Component {
  @service oonClaimSubmissionError;
}
